import fetch from './fetch'

class MediateApi {
	public getList(form: any) {
		return fetch({
			url: 'injury/tasklist/conciliation/list',
			method: 'post',
			data: form,
		})
	}

	public addTask(form: any) {
		return fetch({
			url: '/injury/order/addConciliation',
			method: 'post',
			data: form,
		})
	}

	public exportList(form: any) {
		return fetch({
			url: 'injury/tasklist/conciliation/exportList',
			method: 'post',
			data: form,
			timeout: 0,
			responseType: 'blob',
		})
	}

	public batchExport(orderIds: any[]) {
		return fetch({
			url: 'injury/order/batchExportSurvey',
			method: 'post',
			data: {
				orderIds,
			},
			timeout: 0,
			responseType: 'blob',
		})
	}

	public createConciliation(orderId: string, create: string, form: any) {
		return fetch({
			url: 'injury/order/createConciliation',
			method: 'post',
			data: {
				orderId,
				create,
				...form,
			},
		})
	}

	public auditConciliationTask(form: any) {
		return fetch({
			url: 'injury/task/auditConciliationTask',
			method: 'post',
			data: form,
		})
	}

	public updateConciliationAgreementAmount(form: any) {
		return fetch({
			url: 'injury/order/updateConciliationAgreementAmount',
			method: 'post',
			data: form,
		})
	}

	public auditConciliationAgreement(form: any) {
		return fetch({
			url: 'injury/order/auditConciliationAgreement',
			method: 'post',
			data: form,
		})
	}

	public exportOrder(params: any) {
		return fetch({
			url: 'injury/order/exportConciliationOrder',
			method: 'post',
			params,
		})
	}
}

export default new MediateApi()
